module.exports = __webpack_public_path__ + "05_mole.1a5180d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer2/05_mole.png
// module id = 0q0z
// module chunks = 0